import { render, staticRenderFns } from "./FlappSurveys.vue?vue&type=template&id=9ec6c026"
import script from "./FlappSurveys.vue?vue&type=script&lang=ts"
export * from "./FlappSurveys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports